import styled from "styled-components";

type GradientProps = {
    type?: "linear" | "radial";
    rotation?: string;
    fromColor: string;
    toColor: string;
};

// 1C1C1C -> 454545 linear
const GradientSection = styled.section<GradientProps>`
    background: rgb(28,28,28);
    ${({ fromColor, toColor, type = "linear", rotation = "90deg" }) => (type === "linear"
        ? `background: linear-gradient(${rotation}, ${fromColor} 0%, ${toColor} 100%);`
        : `background: radial-gradient(circle, ${fromColor} 0%, ${toColor} 100%);`)}
`;

export default GradientSection;
